import React from 'react'

import { icons } from '../../assets/icons'
import { useThemedIcon } from '../../hooks/useThemedIcon'

type IconName = keyof typeof icons

export type ThemeIconProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  name: IconName
}

export const ThemeIcon: React.FC<ThemeIconProps> = ({ name, alt, ...props }) => {
  const src = useThemedIcon(name)

  return <img src={src} alt={alt} {...props} />
}

export default ThemeIcon
